$exso_sheets $mol_object
	list /
	value* \
	paths /string
	columns *
	value* \
	parse* null
	hue* \0deg
	unique* /
	order_by /string
	type null unknown
